// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { getI18nFormattedMessage } from '../../utils/intl';
import { ROUTES } from "../../constants/routes";

const LABEL_HOME = getI18nFormattedMessage('label.breadcrumb.home');
const LABEL_APIS = getI18nFormattedMessage('label.breadcrumb.apis');
const LABEL_USERS = getI18nFormattedMessage('label.breadcrumb.users');
const LABEL_TEMPLATES = getI18nFormattedMessage('label.breadcrumb.policy.templates');
const LABEL_APPLICATIONS = getI18nFormattedMessage('label.breadcrumb.applications');
const LABEL_ORGANIZATIONS = getI18nFormattedMessage('label.breadcrumb.organizations');
const LABEL_KEY_STORES = getI18nFormattedMessage('label.breadcrumb.key.stores');
const LABEL_RATE_QUOTAS = getI18nFormattedMessage('label.breadcrumb.rate.quotas');
const LABEL_PRODUCTS = getI18nFormattedMessage('label.breadcrumb.products');
const LABEL_API_PLANS = getI18nFormattedMessage('label.breadcrumb.api.plans');
const LABEL_API_GROUPS = getI18nFormattedMessage('label.breadcrumb.api.groups');
const LABEL_GATEWAY_BUNDLES = getI18nFormattedMessage('label.breadcrumb.gateway.bundles');
const LABEL_SETTINGS = getI18nFormattedMessage('label.breadcrumb.settings');
const LABEL_APPEARANCE = getI18nFormattedMessage('label.breadcrumb.appearance');
const LABEL_APPEARANCE_DETAILS = getI18nFormattedMessage("label.breadcrumb.appearance.details")
const LABEL_EDIT_GLOBAL_THEME = getI18nFormattedMessage("label.breadcrumb.appearance.edit_global_theme")
const LABEL_APPLICATION_AND_KEY_SETTINGS = getI18nFormattedMessage("label.breadcrumb.application_and_key_settings")
const LABEL_APPLICATION_AND_KEY_SETTINGS_AUTH_PROVIDERS = getI18nFormattedMessage("label.breadcrumb.application_and_key_settings.auth_providers");
const LABEL_AUTHENTICATION_SCHEME = getI18nFormattedMessage("label.breadcrumb.authentication.scheme");
const LABEL_PROXIES = getI18nFormattedMessage('label.breadcrumb.proxies');
const LABEL_EULAS = getI18nFormattedMessage('label.breadcrumb.eulas');
const LABEL_CUSTOM_FIELDS = getI18nFormattedMessage('label.breadcrumb.custom.fields');
const LABEL_CUSTOM_PAGES = getI18nFormattedMessage('label.breadcrumb.custom.pages');
const LABEL_MONITOR = getI18nFormattedMessage('label.breadcrumb.monitor');
const LABEL_MY_PROFILE = getI18nFormattedMessage('label.breadcrumb.my.profile');

export const HOME = [
    { isActive: false, link: '', linkName: LABEL_HOME },
];
export const API_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: ROUTES.apiList.path, linkName: LABEL_APIS },
];
export const API_PLANS_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: ROUTES.apiPlansList.path, linkName: LABEL_API_PLANS },
];
export const API_PLANS_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.apiPlansList.path, linkName: LABEL_API_PLANS },
];
export const API_PLANS_ADD = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.apiPlansList.path, linkName: LABEL_API_PLANS },
    { isActive: false, link: ROUTES.apiPlansAdd.path,
    linkName: getI18nFormattedMessage('label.breadcrumb.add') },
];
export const API_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.apiList.path, linkName: LABEL_APIS },
];
export const APPS_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: ROUTES.applicationsList.path, linkName: LABEL_APPLICATIONS },
];
export const APPS_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.applicationsList.path, linkName: LABEL_APPLICATIONS },
];
export const APPLICATION_AND_KEY_SETTINGS = [
  { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
  { isActive: false, link: '', linkName: LABEL_SETTINGS },
  { isActive: false, link: '', linkName: LABEL_APPLICATION_AND_KEY_SETTINGS },
];
export const APPLICATION_AND_KEY_SETTINGS_AUTH_PROVIDER = [
  { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
  { isActive: false, link: '', linkName: LABEL_SETTINGS },
  { isActive: true, link: ROUTES.applicationKeySettings.path,
     linkName: LABEL_APPLICATION_AND_KEY_SETTINGS },
  { isActive: true, link: ROUTES.authProvidersList.path,
    linkName: LABEL_APPLICATION_AND_KEY_SETTINGS_AUTH_PROVIDERS },
]
export const APPEARANCE = [
  { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
  { isActive: false, link: '', linkName: LABEL_SETTINGS },
  { isActive: false, link: '', linkName: LABEL_APPEARANCE },
];
export const APPEARANCE_DETAILS = [
  { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
  { isActive: false, link: '', linkName: LABEL_SETTINGS },
  { isActive: true, link: ROUTES.apperance.path, linkName: LABEL_APPEARANCE },
  { isActive: false, link: '', linkName: LABEL_APPEARANCE_DETAILS },
];
export const APPEARANCE_GLOBAL = [
  { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
  { isActive: false, link: '', linkName: LABEL_SETTINGS },
  { isActive: true, link: ROUTES.apperance.path, linkName: LABEL_APPEARANCE },
  { isActive: false, link: '', linkName: LABEL_EDIT_GLOBAL_THEME },
];
export const GROUPS_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_API_GROUPS },
];
export const GROUPS_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.apiGroupsList.path, linkName: LABEL_API_GROUPS },
];
export const GATEWAY_BUNDLES_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_GATEWAY_BUNDLES },
];
export const GATEWAY_BUNDLES_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.gatewayBundlesList.path, linkName: LABEL_GATEWAY_BUNDLES },
];
export const KEY_STORES_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_KEY_STORES },
];
export const KEY_STORES_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.keyStoresList.path, linkName: LABEL_KEY_STORES },
];
export const ORGS_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_ORGANIZATIONS },
];
export const ORGS_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: '/admin/console/organizations', linkName: LABEL_ORGANIZATIONS },
];
export const TEMPLATE_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link:ROUTES.templateCategoriesList.path, linkName: LABEL_TEMPLATES },
];
export const TEMPLATE_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link:ROUTES.templateCategoriesList.path, linkName: LABEL_TEMPLATES },
];
export const PRODUCT_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: ROUTES.productsList.path, linkName: LABEL_PRODUCTS },
];
export const PRODUCT_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.productsList.path, linkName: LABEL_PRODUCTS },
];
export const RATE_QUOTAS_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: ROUTES.rateQuotasList.path, linkName: LABEL_RATE_QUOTAS },
];
export const RATE_QUOTAS_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.rateQuotasList.path, linkName: LABEL_RATE_QUOTAS },
];
export const USERS_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: ROUTES.usersList.path, linkName: LABEL_USERS },
];
export const USERS_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.usersList.path, linkName: LABEL_USERS },
];
export const PROXIES_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: ROUTES.proxiesList.path, linkName: LABEL_PROXIES },
];
export const PROXIES_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: true, link: ROUTES.proxiesList.path, linkName: LABEL_PROXIES },
];
export const ADMIN_SETTINGS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_SETTINGS },
];
export const ADMIN_SETTINGS_AUTH_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_SETTINGS },
    { isActive: false, link: ROUTES.authList.path, linkName: LABEL_AUTHENTICATION_SCHEME },
];
export const ADMIN_SETTINGS_AUTH_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_SETTINGS },
    { isActive: true, link: ROUTES.authList.path, linkName: LABEL_AUTHENTICATION_SCHEME },
];
export const EULAS_LIST = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_SETTINGS },
    { isActive: false, link: '', linkName: LABEL_EULAS },
];
export const EULAS_DETAILS = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_SETTINGS },
    { isActive: true, link: ROUTES.eulasList.path, linkName: LABEL_EULAS },
];
export const MONITOR = [
  { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
  { isActive: false, link: '/', linkName: LABEL_MONITOR },
];
export const CUSTOM_FIELD_LIST = [
  { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
  { isActive: false, link: '', linkName: LABEL_SETTINGS },
  { isActive: false, link: '', linkName: LABEL_CUSTOM_FIELDS },
];
export const CUSTOM_FIELD_DETAIL = [
  { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
  { isActive: false, link: '', linkName: LABEL_SETTINGS },
  { isActive: true, link: ROUTES.customFieldsList.path, linkName: LABEL_CUSTOM_FIELDS },
];
export const CUSTOM_PAGE = [
  { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
  { isActive: false, link: ROUTES.customPagesList.path, linkName: LABEL_CUSTOM_PAGES },
];

export const MY_PROFILE = [
    { isActive: true, link: ROUTES.adminHome.path, linkName: LABEL_HOME },
    { isActive: false, link: '', linkName: LABEL_MY_PROFILE },
  ];
